import { api } from '@/api';
import type { DeviceQueryParams, DeviceResponse, DeviceCountParams, DeviceCountResponse } from '../types';

export async function fetchDevices(
  companyId: string,
  params: DeviceQueryParams
): Promise<DeviceResponse> {
  const queryParams: Record<string, string | number | boolean | undefined> = {
    page: params.page,
    pageSize: params.pageSize,
    search: params.search || undefined,
    sortBy: params.sortBy || undefined,
    sortOrder: params.sortOrder || undefined,
    companyId: params.companyId || undefined,
  };

  return api.get<DeviceResponse>(`/v1/companies/${companyId}/devices`, { params: queryParams });
}

export async function fetchDevicesCount(
  companyId: string,
  params: DeviceCountParams,
  pageSize: number
): Promise<DeviceCountResponse> {
  const queryParams: Record<string, string | undefined> = {
    search: params.search || undefined,
    pageSize: pageSize.toString()
  };

  const response = await api.get<{ total: number }>(`/v1/companies/${companyId}/devices/count`, { params: queryParams });

  return {
    total: response.total,
    totalPages: Math.ceil(response.total / pageSize),
  };
}

export async function deleteDevices(
  deviceIds: string[]
): Promise<void> {
  await api.delete(`/v1/devices`, { deviceIds });
}
